import React from 'react';
import { Webhook } from 'lucide-react';
import ModalShell from './ModalShell';
import WebhookAlertsPanel from './WebhookAlertsPanel';

export default function WebhookAlertsModal({
  apiToken,
  buildRequestHeaders,
  getApiUrl,
  isAdminAuthenticated,
  onClose,
  portals
}) {
  return (
    <ModalShell
      icon={Webhook}
      maxWidthClass="max-w-3xl"
      onClose={onClose}
      subtitle="Configure webhooks para receber notificações em tempo real no Discord, Slack ou outros serviços."
      themeClass="bg-gradient-to-r from-indigo-600 via-blue-500 to-cyan-500"
      title="Configurar Webhooks"
    >
      <div className="p-4 sm:p-6 max-h-[80vh] overflow-y-auto bg-gray-50 dark:bg-gray-950">
        <WebhookAlertsPanel
          apiToken={apiToken}
          buildRequestHeaders={buildRequestHeaders}
          getApiUrl={getApiUrl}
          isAdminAuthenticated={isAdminAuthenticated}
          portals={portals}
        />
      </div>
    </ModalShell>
  );
}
